import {Injectable} from '@angular/core';
import { OrderStatusEnum, PersonStatusEnum } from '../enums/status.enum';
import {ConditionsCheckEnum} from '../enums/conditionsCheck.enum';
import {Role} from '../enums/role.enum';
import {UserActionEnum} from '../enums/userActions.enum';
import {EntityNameEnum} from '../enums/entityName.enum';
import { ReportEnum } from '../enums/report.enum';

@Injectable({
    providedIn: 'root'
})
export class EnumTranslateService {

    private statusTranslations: { [key: string]: string } = {
        [OrderStatusEnum.active]: 'Не распределена',
        [OrderStatusEnum.done]: 'Выполнена',
        [OrderStatusEnum.destributed]: 'Распределена',
        [OrderStatusEnum.ready]: 'К выполнению',
        [OrderStatusEnum.onway]: 'В пути',
        [OrderStatusEnum.reject]: 'Отклонена',
        [OrderStatusEnum.atwork]: 'В работе',
    };

    private actionsTranslations: { [key: string]: string } = {
        [UserActionEnum.create]: 'Создано',
        [UserActionEnum.update]: 'Обновлено',
        [UserActionEnum.delete]: 'Удалено',
    };

    private personStatusTranslations: { [key: string]: string } = {
        [PersonStatusEnum.active]: 'Активен',
        [PersonStatusEnum.inactive]: 'Неактивен',
    };

    private reportTranslations: { [key: string]: string } = {
        [ReportEnum.WORKER_LOAD]: 'Отчет по загрузке работников',
    };

    private conditionsCheckTranslations: { [key: string]: string } = {
        [ConditionsCheckEnum.true]: 'Подтверждено',
        [ConditionsCheckEnum.false]: 'Не подтверждено',
    };

    private roleTranslations: { [key: string]: string } = {
        [Role.executor]: 'Работник',
        [Role.customer]: 'Заказчик',
        [Role.manager]: 'Менеджер',
        [Role.admin]: 'Администратор',
    };

    private entityNameTranslations: { [key: string]: string } = {
        [EntityNameEnum.order]: 'Заявки',
        [EntityNameEnum.person]: 'Контакты',
        [EntityNameEnum.price]: 'Прайсы',
        [EntityNameEnum.work]: 'Виды работ',
        [EntityNameEnum.category]: 'Категории',
        [EntityNameEnum.project]: 'Проекты',
        [EntityNameEnum.location]: 'Адреса',
        [EntityNameEnum.item]: 'Оборудование',
        [EntityNameEnum.customFieldsConfig]: 'Настраиваемые поля',
        [EntityNameEnum.company]: 'Компании',
    };

    translateStatus(status: string): string {
        return this.statusTranslations[status] || '';
    }

    translateAction(status: string): string {
        return this.actionsTranslations[status] || '';
    }

    translateEntitiesName(status: string): string {
        return this.entityNameTranslations[status] || '';
    }

    translateConditionsCheck(status: string): string {
        return this.conditionsCheckTranslations[status] || '';
    }

    translateRole(status: string): string {
        return this.roleTranslations[status] || '';
    }

    translatePersonStatus(status: string): string {
        return this.personStatusTranslations[status] || '';
    }

    translateReportStatus(status: string): string {
        return this.reportTranslations[status] || '';
    }

}
